/*
 * @Author: kongxiangyu
 * @Date: 2022-11-19 14:06:00
 * @LastEditTime: 2023-02-10 12:43:44
 * @email: kongxiangyu@cd.baidu.com
 * @Description: Do not edit
 */
/**
 * @file Constant.js
 * @desc 常量，包含接口路径，独立页面内公共常量
 * @author ~~
 * @data 2020/06/17
 */
import meishi from '../assets/coupon-meishi.png';
import btn1 from '../assets/meishi1.png';
import btn2 from '../assets/meishi2.png';
import btn3 from '../assets/meishi3.png';
import btn4 from '../assets/meishi4.png';
import btn5 from '../assets/meishi5.png';
import jiayou from '../assets/coupon-jiayou.png';
import meishiShort1 from '../assets/big-ms1.png';
import meishiShort2 from '../assets/meishi-short-2.png';
import meishiShort3 from '../assets/meishi-short-3.png';
import meishiShort4 from '../assets/meishi-short-4.png';
import meishiShort5 from '../assets/meishi-short-5.png';
import meishiLong1 from '../assets/big-ms2.png';
import meishiLong2 from '../assets/meishi-long-2.png';
import meishiLong3 from '../assets/meishi-long-3.png';
import meishiLong4 from '../assets/meishi-long-4.png';
import meishiLong5 from '../assets/meishi-long-5.png';
import bigBtn1 from '../assets/big-buy.gif';
import bigBtn2 from '../assets/bigBtn2.png';
import circleLight from '../assets/circle1.png';
import circleDark from '../assets/circleDark.png';

const Const = {};
// 开发机环境
if (process.env.NODE_ENV === 'development') {
    Const.goodlist = 'https://maphotel.baidu.com/';
    Const.server = 'http://rokey.bcc-szzj.baidu.com:8083/';
    // Const.server = 'https://newclient.map.baidu.com/';
}
// QA环境
else if (process.env.NODE_ENV === 'test') {
    Const.goodlist = 'https://maphotel.baidu.com/';
    // Const.server = 'http://guozhaoran.bcc-gzbh.baidu.com:8080/';
    Const.server = 'https://newclient.map.baidu.com/';
}

// 线上环境
else {
    Const.goodlist = 'https://maphotel.baidu.com/';
    // Const.server = 'http://guozhaoran.bcc-gzbh.baidu.com:8080/';
    Const.server = 'https://newclient.map.baidu.com/';
    // Const.server = 'http://rokey.bcc-szzj.baidu.com:8083/';

}

// 获取主页面数据
Const.MainData = 'living/growth/activity/detail';
Const.OrderData = 'living/growth/coupon/user-orders';
Const.PacketRevive = 'living/growth/promotion/coupon-receive';
Const.TplRefresh = 'living/growth/activity/detail';
Const.GetCoupons = 'living/growth/user/coupon-package';
Const.GetOrderStatus = 'living/growth/coupon/order-status';
Const.GetGoodList = 'vertical-service/external/caterlist';

Const.dataUrl = {
    GetGoodList: {
        isMock: 0,
        url: Const.goodlist + Const.GetGoodList
    },
    GetCoupons: {
        isMock: 0,
        url: Const.server + Const.GetCoupons
    },
    MainData: {
        isMock: 0,
        url: Const.server + Const.MainData
    },
    OrderData: {
        isMock: 0,
        url: Const.server + Const.OrderData
    },
    PacketRevive: {
        isMock: 0,
        url: Const.server + Const.PacketRevive
    },
    FoodCouponPopup: {
        isMock: 0,
        url: Const.server + Const.getCoupons
    },
    TplRefresh: {
        isMock: 0,
        url: Const.server + Const.TplRefresh
    },
    GetOrderStatus: {
        isMock: 0,
        url: Const.server + Const.GetOrderStatus
    }
};

// 客户端信息
Const.nativeInfo = {};
Const.couponTypeMap = {
    1: {
        bg: meishi
    },
    5: {
        bg: meishi
    },
    100: {
        bg: jiayou
    },
    btn: {
        '-1': {
            btn: btn1,
            action: 'get'
        }, // 待领取
        0: {
            btn: btn2,
            action: 'jump'
        }, // 去使用
        80: {
            btn: btn3,
            action: ''
        }, // 已使用
        101: {
            btn: btn4,
            action: ''
        }, // 已抢光
        100: {
            btn: btn5,
            action: ''
        } // 已过期
    }
};
Const.bigPacketMap = {
    short: {
        '-1': meishiShort1,
        0: meishiShort2,
        80: meishiShort3,
        100: meishiShort5,
        101: meishiShort4
    },
    long: {
        '-1': meishiLong1,
        0: meishiLong2,
        80: meishiLong3,
        100: meishiLong5,
        101: meishiLong4
    }
};
Const.bigPacketBtnMap = {
    0: bigBtn1, // 去购买
    10: bigBtn2, // 去使用
    20: bigBtn1
};
Const.circleMap = {
    '-1': {
        bg: circleLight,
        text: '1分抢'
    },
    0: {
        bg: circleLight,
        text: '去使用'
    },
    80: {
        bg: circleDark,
        text: '已使用'
    },
    100: {
        bg: circleDark,
        text: '已过期'
    },
    101: {
        bg: circleDark,
        text: '已抢光'
    }
};
export default Const;
